import { createContext, useContext, useMemo, useState } from 'react';
import noop from 'lodash/noop';
import { useResizeObserver } from '@atlassian/jira-react-use-resize-observer/src/index.tsx';

export const VISIBILITY_BREAKPOINT = 230;
type RefSetter = (el: HTMLDivElement | null) => void;
type ContextValue = {
	setRef: RefSetter;
};
export const useAdditionalFieldsMinimumWidth = (): {
	contextValue: ContextValue;
	isTooNarrow: boolean;
} => {
	const [reactiveRef, setReactiveRef] = useState<HTMLDivElement | null>(null);
	const [isTooNarrow, setIsTooNarrow] = useState(false);
	const stableRef = useMemo(() => {
		return {
			current: reactiveRef,
		};
	}, [reactiveRef]);

	useResizeObserver({
		ref: stableRef,
		onResize: () => {
			if (!stableRef) return;
			const width = stableRef.current?.offsetWidth ?? 0;
			setIsTooNarrow(width < VISIBILITY_BREAKPOINT);
		},
	});
	return {
		contextValue: {
			setRef: setReactiveRef,
		},
		isTooNarrow,
	};
};

export const AdditionalFieldsContainerRefContext = createContext<ContextValue>({ setRef: noop });
export const useAdditionalFieldsContainerRefContext = () =>
	useContext(AdditionalFieldsContainerRefContext);
